import React,{useState} from 'react';
import RegisterForm from '../components/RegisterForm';
import { RegisterFormData } from '../types/RegisterFormData';
import { useAuth} from '../../providers/authProvider';
import { useNavigate } from 'react-router-dom';
import { pageNames } from '../../config/pageNames';
import { saveUserDetails } from '../utils/RegisterApi';
import { RegistrationData } from '../types/RegistrationData';
import { getUserLocation } from 'auth/utils/geoHelper';
import { formatAuthError } from 'auth/utils/errorHelper';

export const RegisterPage = () => {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onRegister = async (regInfo: RegisterFormData) =>{

    try {
      setIsLoading(true);
      const {user} = await signUp(regInfo.email, regInfo.password);
      const location = await getUserLocation();
      
      await saveUserDetails(
        user.uid,
        {
          name: regInfo.name,
          email: user.email,
          company: '',
          country: location.country,
          city: location.city,
          gdprOptout: regInfo.gdprConfirm,
          heardFrom: regInfo.heardFrom,
          heardFromOther: regInfo.heardFromOther 
        } as RegistrationData);

      try {
        setIsLoading(false);
        navigate(pageNames.ACTIONS_INTRO);
      } catch (error) {
        const message = formatAuthError(error);
        setErrorMessage(message);
        console.log(`🚀 ~ signup error`, message);
        setErrorMessage(message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      const message = formatAuthError(error);
      setErrorMessage(message);
      console.log(`🚀 ~ signup error`, message);
    }

  }

  return (
    <div>
        <RegisterForm 
          onSubmit={onRegister} 
          isLoading={isLoading}
          errorMessage={errorMessage}
        />
    </div>
  );
};

